export default __webpack_public_path__ + "static/media/art-pro-slt-1.11f3317e.png";